import { render, staticRenderFns } from "./ProfessionalInfo_1.vue?vue&type=template&id=b86bd9b8"
import script from "./ProfessionalInfo_1.vue?vue&type=script&lang=js"
export * from "./ProfessionalInfo_1.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports